module.exports = __webpack_public_path__ + "static/media/cover-patagonia.3063dee8.png";